import { Routes } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';
import { amsGuard } from '@guards/ams.guard';
import { clientsGuard } from '@guards/clients.guard';
import { teamTrackingGuard } from '@guards/team-tracking.guard';
import { ROUTE_PATHS } from '@routes/app-routes.constants';

export const routes: Routes = [
  {
    path: ROUTE_PATHS.login,
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  { path: ROUTE_PATHS.home, redirectTo: ROUTE_PATHS.projects.root, pathMatch: 'full' },
  {
    path: ROUTE_PATHS.projects.root,
    loadChildren: () => import('./routes/coding.route').then((m) => m.CODING_ROUTES),
  },
  {
    path: ROUTE_PATHS.admin.root,
    loadChildren: () => import('./routes/admin.route').then((m) => m.ADMIN_ROUTES),
  },
  {
    path: ROUTE_PATHS.clients.root,
    canActivate: [AuthGuard, clientsGuard],
    loadChildren: () => import('./routes/clients.route').then((m) => m.CLIENTS_ROUTES),
  },
  {
    path: ROUTE_PATHS.ams.root,
    canActivate: [AuthGuard, amsGuard],
    loadChildren: () => import('./routes/ams.route').then((m) => m.AMS_ROUTES),
  },
  {
    path: ROUTE_PATHS.teamTracking.root,
    canActivate: [AuthGuard, teamTrackingGuard],
    loadChildren: () => import('./routes/team-tracking.route').then((m) => m.TEAM_TRACKING_ROUTES),
  },
  {
    path: ROUTE_PATHS.accessDenied,
    loadComponent: () =>
      import('./pages/access-denied/access-denied.component').then((m) => m.AccessDeniedComponent),
  },
  { path: '**', redirectTo: ROUTE_PATHS.projects.root },
];
